import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "animate-spin h-10 w-10 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = {
  key: 1,
  class: "flex px-4 py-5 m-auto text-white"
}
const _hoisted_4 = { class: "flex flex-col items-center space-y-6" }
const _hoisted_5 = {
  key: 2,
  class: "flex px-4 py-5 m-auto text-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_in_app_subscription = _resolveComponent("in-app-subscription")!
  const _component_chat_list_item = _resolveComponent("chat-list-item")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_ion_buttons, {
                  class: "flex",
                  slot: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      onClick: _ctx.goBack,
                      class: "bg-brand-dark-gray rounded-md"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("svg", {
                          class: "",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            d: "M6 11.9961H18",
                            stroke: "white",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }),
                          _createElementVNode("path", {
                            d: "M12 18L6 12L12 6",
                            stroke: "white",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ], -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex w-full ml-4" }, [
                      _createElementVNode("div", { class: "text-white font-medium text-2xl border-b-2 border-t border-transparent" }, "Archived")
                    ], -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "h-full" }, {
        default: _withCtx(() => [
          (_ctx.isSubscribed)
            ? (_openBlock(), _createBlock(_component_ion_refresher, {
                key: 0,
                slot: "fixed",
                onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pullToRefresh($event)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_refresher_content, {
                    "pulling-icon": "crescent",
                    "refreshing-spinner": "crescent"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["flex", {
                'h-full' : !_ctx.chats.length || _ctx.loading
            }])
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }, null, -1),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (!_ctx.isSubscribed  && !_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[4] || (_cache[4] = _createElementVNode("svg", {
                      width: "75",
                      height: "74",
                      viewBox: "0 0 75 74",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M37.5006 0C17.2891 0 0.845703 16.4434 0.845703 36.6549C0.845703 56.8664 17.2891 73.3098 37.5006 73.3098C57.7121 73.3098 74.1555 56.8664 74.1555 36.6549C74.1555 16.4434 57.7121 0 37.5006 0Z",
                        fill: "#EBFF00"
                      }),
                      _createElementVNode("path", {
                        d: "M57.344 45.3167C58.4435 46.0038 58.7864 47.4604 57.9969 48.4889C55.9488 51.1572 53.3663 53.3809 50.4055 55.0124C46.7574 57.0225 42.6561 58.0668 38.4909 58.0461C34.3257 58.0254 30.235 56.9404 26.6071 54.8941C23.6626 53.2332 21.1024 50.984 19.0809 48.2954C18.3017 47.2591 18.659 45.806 19.7653 45.1298C20.8716 44.4537 22.3061 44.8129 23.1088 45.8312C24.6966 47.8454 26.6667 49.5371 28.9137 50.8045C31.8446 52.4577 35.1494 53.3342 38.5142 53.3509C41.8791 53.3677 45.1924 52.524 48.1396 50.9001C50.3991 49.6551 52.3859 47.9831 53.9937 45.9847C54.8064 44.9745 56.2445 44.6295 57.344 45.3167Z",
                        fill: "#1A1B22"
                      }),
                      _createElementVNode("path", {
                        d: "M24.5105 40.1582C25.6758 40.2425 26.5724 41.2661 26.2606 42.392C26.0533 43.1407 25.7645 43.8666 25.3979 44.5563C24.6993 45.8709 23.7338 47.0251 22.5633 47.9449C21.3928 48.8648 20.043 49.53 18.6006 49.8981C17.8437 50.0912 17.0701 50.2003 16.2937 50.2247C15.1259 50.2615 14.3434 49.1483 14.5369 47.9961C14.7304 46.8439 15.8401 46.1029 16.9933 45.9156C17.1817 45.8849 17.3689 45.846 17.5545 45.7986C18.4262 45.5762 19.2417 45.1742 19.949 44.6184C20.6563 44.0625 21.2397 43.3651 21.6619 42.5708C21.7518 42.4016 21.834 42.2289 21.9082 42.0531C22.3629 40.9768 23.3453 40.0738 24.5105 40.1582Z",
                        fill: "#1A1B22"
                      }),
                      _createElementVNode("path", {
                        d: "M32.9536 30.0211C33.9533 29.3009 34.1629 27.8739 33.2204 27.0804C32.4583 26.4388 31.6057 25.8977 30.6849 25.4747C29.0674 24.7316 27.287 24.3744 25.4949 24.4336C23.7028 24.4927 21.9521 24.9664 20.3917 25.8144C19.5056 26.2959 18.6958 26.89 17.9827 27.5781C17.0949 28.4348 17.4025 29.8458 18.45 30.4975C19.4438 31.1157 20.7341 30.7992 21.6606 30.0839C21.9433 29.8657 22.2449 29.669 22.5627 29.4963C23.5056 28.9839 24.5635 28.6977 25.6463 28.6619C26.7292 28.6262 27.8051 28.842 28.7824 29.291C29.1166 29.4445 29.4358 29.6237 29.7373 29.8263C30.7047 30.4766 32.0077 30.7024 32.9536 30.0211Z",
                        fill: "#1A1B22"
                      }),
                      _createElementVNode("path", {
                        d: "M51.5546 32.8109C54.0696 32.8109 56.1406 30.849 56.1406 28.39C56.1406 25.9309 54.0696 23.9691 51.5546 23.9691C49.0396 23.9691 46.9686 25.9309 46.9686 28.39C46.9686 30.849 49.0396 32.8109 51.5546 32.8109Z",
                        fill: "#1A1B22",
                        stroke: "#1A1B22",
                        "stroke-width": "0.916372"
                      })
                    ], -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-4 px-2" }, [
                      _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Hey sweet stuff, this is a premium feature. "),
                      _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, "Subscribe today to flirt with any and all profiles who you feel a connection with ")
                    ], -1)),
                    _createVNode(_component_in_app_subscription, {
                      class: "w-full",
                      label: "Upgrade to Pineapple Premium"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSubscribed && !_ctx.loading && !_ctx.chats.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                    _createElementVNode("div", { class: "flex m-auto text-brand-lime" }, [
                      _createElementVNode("svg", {
                        class: "w-16 h-16 fill-current",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512"
                      }, [
                        _createElementVNode("path", { d: "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z" })
                      ])
                    ]),
                    _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-4 px-2" }, [
                      _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Your archive is empty! ")
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.isSubscribed && !_ctx.loading && _ctx.chats.length)
              ? (_openBlock(), _createBlock(_component_ion_list, {
                  key: 3,
                  lines: "none",
                  class: "py-4 flex flex-col w-full text-white space-y-4 bg-brand-black"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (chat, chatIndex) => {
                      return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                        class: "",
                        key: chat.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_chat_list_item, { chat: chat }, null, 8, ["chat"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_item_options, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item_option, {
                                class: "bg-red-500 text-white font-medium",
                                onClick: ($event: any) => (_ctx.deleteChat(chat.id, chatIndex))
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createElementVNode("div", { class: "px-4 flex flex-col space-y-1" }, [
                                    _createElementVNode("div", { class: "flex m-auto" }, [
                                      _createElementVNode("svg", {
                                        class: "w-6 h-6 fill-current",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 448 512"
                                      }, [
                                        _createElementVNode("path", { d: "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" })
                                      ])
                                    ]),
                                    _createElementVNode("div", null, "Delete")
                                  ], -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_ion_item_option, {
                                class: "bg-brand-lime text-brand-black font-medium",
                                onClick: ($event: any) => (_ctx.unarchiveChat(chat.id, chatIndex))
                              }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createElementVNode("div", { class: "px-4 flex flex-col space-y-1" }, [
                                    _createElementVNode("div", { class: "flex m-auto" }, [
                                      _createElementVNode("svg", {
                                        class: "w-6 h-6 fill-current",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 512 512"
                                      }, [
                                        _createElementVNode("path", { d: "M288 109.3V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z" })
                                      ])
                                    ]),
                                    _createElementVNode("div", null, "Unarchive")
                                  ], -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}